import { Grid } from '@mui/material';
import { type Dayjs } from 'dayjs';
import { isEqual } from 'lodash';
import { useState } from 'react';

import Filters from './Filters';
import TasksListTable from './TasksListTable';

import { type TaskStatusEnum, type TaskPriorityEnum, type TaskEntity } from '@/graphql/generated/graphql';

export const DEFAULT_FILTERS = {
  createdById: '',
  assigneeId: '',
  status: '' as TaskStatusEnum,
  priority: '' as TaskPriorityEnum,
  searchText: '',
  entity: {} as TaskEntity,
  dueDateFrom: null as Dayjs | null,
  dueDateTo: null as Dayjs | null,
};

export type TasksFiltersType = typeof DEFAULT_FILTERS;

const TasksTab: React.FC = () => {
  const [filters, setFilters] = useState<TasksFiltersType>(DEFAULT_FILTERS);
  const [showFilters, setShowFilters] = useState<boolean>(false);

  return (
    <Grid container padding={2} size={12}>
      {showFilters && (
        <Filters
          filters={filters}
          onChange={(key, value) => setFilters((prev) => ({ ...prev, [key]: value }))}
          onReset={() => setFilters(DEFAULT_FILTERS)}
          disableResetButton={isEqual(filters, DEFAULT_FILTERS)}
        />
      )}
      <TasksListTable setShowFilters={setShowFilters} filters={filters} />
    </Grid>
  );
};

export default TasksTab;
